import { render, staticRenderFns } from "./FilesUploader.vue?vue&type=template&id=a7ac1e92&lang=pug&"
import script from "./FilesUploader.ts?vue&type=script&lang=js&"
export * from "./FilesUploader.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports